module.exports = __webpack_public_path__ + "img/WorldBuildingEventEntranceOpen.3a397810.png";